<div class="phone" *ngIf="!phoneSuccessflly" style="overflow: hidden">
    <div class="verify">
        <div class="d-flex justify-content-between">
            <h5
                class="main-font"
                style="
                    margin-bottom: 24px;
                    margin-left: 10px;
                    font-size: 17px;
                    text-transform: capitalize;
                "
            >
            {{( environmentVariables?.COUNTRY_CODE == 'SA' ? 
               user?.phone ? "ARSA.editPhone" : "ARSA.addPhoneNumber"
             : user?.phone ? "verify.editPhone" : "verify.addPhoneNumber"  ) | translate}}
            </h5>
            <div class="close-btn-outer">
                <button mat-mini-fab color="warn" (click)="close()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <div mat-dialog-content style="overflow: visible !important">
            <form [formGroup]="phoneForm" (submit)="submitPhone()">
                <div fxLayout="row wrap">
                    <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
                        <mat-form-field
                            class="w-100 mb-3 main-font phone-form-field"
                        >
                            <span
                                class="localization-data"
                                *ngIf="environmentVariables?.localization"
                                ><img  loading="lazy" 
                                    [src]="
                                        environmentVariables?.localization?.flag
                                    "
                                       alt="country flag"
                                />
                                {{
                                    environmentVariables?.localization
                                        ?.phone_prefix
                                }}</span
                            >
                            <input
                                matInput
                                [minLength]="
                                    environmentVariables?.localization
                                        ?.phone_length < 1000
                                        ? environmentVariables?.localization
                                              ?.phone_length
                                        : 0
                                "
                                [maxLength]="
                                    environmentVariables?.localization
                                        ?.phone_length
                                "
                                placeholder="
                                {{ ( environmentVariables?.COUNTRY_CODE == 'SA' ? 'ARSA.inputPhone' : 'input_text.inputPhone' ) | translate }}
                                "
                                formControlName="phone"
                                (keypress)="numberOnly($event)"
                                pattern="\d*"
                                inputmode="numeric"
                            />
                            
                            <mat-error
                                *ngIf="
                                    formControlValidator(
                                        phoneForm,
                                        'phone',
                                        'required'
                                    )
                                "
                            >
                                <ng-container *ngIf="environmentVariables?.COUNTRY_CODE == 'SA'; else nonSA">
                                  {{ "ARSA.requiredPhone" | translate }}
                                </ng-container>
                                <ng-template #nonSA>
                                    {{ "validation_Input.requiredPhone" | translate }}
                                </ng-template>
                            </mat-error>
                            <mat-error
                                *ngIf="
                                    formControlValidator(
                                        phoneForm,
                                        'phone',
                                        'maxlength'
                                    ) ||
                                    formControlValidator(
                                        phoneForm,
                                        'phone',
                                        'minlength'
                                    )
                                "
                            >
                                {{
                                    lang == "en"
                                        ? "Phone number must be " +
                                          environmentVariables?.localization
                                              ?.phone_length +
                                          " digits "
                                        : "رقم التليفون يجب ان يكون " +
                                          environmentVariables?.localization
                                              ?.phone_length +
                                          " رقم"
                                }}
                            </mat-error>
                            <mat-error
                                *ngIf="
                                    formControlValidator(
                                        phoneForm,
                                        'phone',
                                        'pattern'
                                    ) &&
                                    !(
                                        formControlValidator(
                                            phoneForm,
                                            'phone',
                                            'maxlength'
                                        ) ||
                                        formControlValidator(
                                            phoneForm,
                                            'phone',
                                            'minlength'
                                        )
                                    )
                                "
                            >
                                <ng-container *ngIf="environmentVariables?.COUNTRY_CODE == 'SA'; else nonSA">
                                  {{ "ARSA.phoneNumberPattern" | translate }}
                                </ng-container>
                                <ng-template #nonSA>
                                    {{ "validation_Input.phoneNumberPattern" | translate }}
                                </ng-template>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div
                        fxFlex="100"
                        class="text-center mt-2 media-margin-button"
                        style="margin-top: 45px"
                    >
                        <button mat-raised-button color="primary">
                            {{ "button.buttonSubmit" | translate }}
                            <div
                                class="toggle-loading"
                                *ngIf="updatePhoneLoading"
                            >
                                <app-loading></app-loading>
                            </div>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div
    class="verify main-font"
    *ngIf="phoneSuccessflly && environmentVariables?.SMS_CONNECTION"
>
    <h5
        style="
            margin-left: 10px;
            font-size: 17px;
            text-transform: capitalize;
            text-align: center;
            margin-bottom: 0px;
        "
    >
        <ng-container *ngIf="environmentVariables?.COUNTRY_CODE == 'SA'; else nonSA">
          {{ "ARSA.editPhoneNumberTitle" | translate }}
        </ng-container>
        <ng-template #nonSA>
        </ng-template>
    </h5>
    <p class="text-muted text-center main-font">
        <ng-container *ngIf="environmentVariables?.COUNTRY_CODE == 'SA'; else nonSA">
          {{ "ARSA.headerVerifcationCode" | translate }}
        </ng-container>
        <ng-template #nonSA>
            {{ "verify.headerVerifcationCode"  | translate }}
        </ng-template>
        <span *ngIf="user?.phone">{{ user?.phone }}</span>
    </p>
    <div class="d-flex justify-center align-content-center mb-2">
        <p
            class="text-muted text-center d-inline-flex edit-phone main-font"
            (click)="editPhone()"
        >
            <ng-container *ngIf="environmentVariables?.COUNTRY_CODE == 'SA'; else nonSA">
              {{ "ARSA.editPhone" | translate }}
            </ng-container>
            <ng-template #nonSA>
                {{  "verify.editPhone" | translate }}
            </ng-template>
        </p>
    </div>

    <div mat-dialog-content style="overflow: visible !important">
        <form [formGroup]="verifyForm">
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
                    <mat-form-field
                        class="w-100"
                        [ngClass]="{ 'text-right': lang == 'ar' }"
                    >
                        <input
                            id="verifyCodeId"
                            class="main-font"
                            matInput
                            placeholder="{{ 'verify.enterCode' | translate }}"
                            formControlName="code"
                            required
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57 "
                            #verifyCodeInput
                            (blur)="onBlur(1)"
                        />
                        <mat-error
                            [ngClass]="{ 'text-right': lang == 'ar' }"
                            *ngIf="showInputErrorEnterCode"
                        >
                            {{ "validation_Input.requiredCode" | translate }}
                        </mat-error>
                    </mat-form-field>
                    <button
                        class="resend main-font"
                        type="button"
                        (click)="resendCode()"
                    >
                        {{ "button.resend" | translate }}
                    </button>
                </div>
                <div
                    fxFlex="100"
                    class="text-center mt-2 media-margin-button"
                    style="margin-top: 45px"
                >
                    <button
                        mat-raised-button
                        color="primary"
                        class="main-font"
                        (click)="submitCodeAndCreateOrder()"
                        *ngIf="data.create_order"
                    >
                        {{ "button.buttonSubmit" | translate }}
                        <div class="toggle-loading" *ngIf="verifyLoading">
                            <app-loading></app-loading>
                        </div>
                    </button>
                    <button
                        mat-raised-button
                        color="primary"
                        class="main-font"
                        (click)="submitCode()"
                        *ngIf="!data.create_order"
                    >
                        {{ "button.buttonSubmit" | translate }}
                        <div class="toggle-loading">
                            <app-loading *ngIf="verifyLoading"></app-loading>
                        </div>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
